export default __webpack_public_path__ + "static/media/Capturetemp-removebg-preview.a81f1ec9.png";